import { getShouldUseCSPhone } from '~/growthbook';

export const NumberUtils = {
  /**
   * @param phone +18558794688
   * @param style traditional | simplified
   * @returns traditional: (855) 879-4688
   * @returns simplified: 855-879-4688
   */
  formatUSPhoneNumber(phone: string, style: 'traditional' | 'simplified') {
    const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
    const match = cleaned.match(/^1?(\d{3})(\d{3})(\d{4})$/); // Optional country code +1
    if (match) {
      const [, areaCode, centralOffice, lineNumber] = match;

      if (style === 'traditional') {
        return `(${areaCode}) ${centralOffice}-${lineNumber}`;
      }

      return `${areaCode}-${centralOffice}-${lineNumber}`;
    }

    return phone; // Return original if it doesn't match pattern
  },
  /**
   * get CS phoneNumber
   * @returns {default: '+18558794688', formatted: '(855) 879-4688', formattedSimplified: '855-879-4688',}
   */
  getCSPhone() {
    const defaultPhoneNumber = '+17864602170';
    const phone = getShouldUseCSPhone?.() ?? defaultPhoneNumber;

    return {
      default: phone,
      formatted: NumberUtils.formatUSPhoneNumber(phone, 'traditional'),
      formattedSimplified: NumberUtils.formatUSPhoneNumber(phone, 'simplified'),
    };
  },
};
